<template>
    <div class="form">

        <!-- options -->
        <div class="form__section">
            <div class="form__title">Fahrradstrecken</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.bikeParameters" 
                        :options="bikeParameterOptions"
                        :tracking-data-label="'Bike'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        @change="fieldChangeHandler($event, 'bikeParameters')"
                    />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'

export default {
    components: {
        SmrChoiceGroup,

    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            bikeParameterOptions: [
                {value: 'avoidInclines', label: 'Steile Anstiege vermeiden<br> (nur in Österreich)', trackingLabel: 'Avoid Inclines', increasedSpace: true},
                {value: 'preferCyclingInfrastructure', label: 'Radinfrastruktur bevorzugt nutzen <br> (nur in Österreich)', trackingLabel: 'Prefer Bike Lanes', increasedSpace: true},
            ],
        }
    },

}
</script>
